import { create } from 'zustand';

export type Lang = 'fr' | 'en';

interface LangState {
  lang: Lang;
  setLang: (l: Lang) => void;
}

const saved = (localStorage.getItem('taj_lang') as Lang) || 'fr';

/** Langue de l'interface, partagée par tous les écrans et mémorisée. */
export const useLang = create<LangState>((set) => ({
  lang: saved,
  setLang: (lang) => {
    localStorage.setItem('taj_lang', lang);
    set({ lang });
  },
}));
